module.exports = __webpack_public_path__ + "img/pijl-scroll-verder.516cd89c13082583954c0bd3ab04368f.svg";